import type { HTMLAttributes, PropsWithChildren, ReactNode } from "react";
import { classNames } from "@app/utils/classNames";

type CardProps = PropsWithChildren<
  HTMLAttributes<HTMLElement> & {
    title?: ReactNode;
    subtitle?: ReactNode;
    actions?: ReactNode;
    className?: string;
    bodyClassName?: string;
    id?: string;
  }
>;

export function Card({
  title,
  subtitle,
  actions,
  className,
  bodyClassName,
  children,
  id,
  ...rest
}: CardProps) {
  const showHeader = Boolean(title || subtitle || actions);

  return (
    <section id={id} className={classNames("ui-card", className)} {...rest}>
      {showHeader ? (
        <header className="ui-card__header">
          <div className="ui-card__header-text">
            {title ? <h3 className="ui-card__title">{title}</h3> : null}
            {subtitle ? <p className="ui-card__subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="ui-card__actions">{actions}</div> : null}
        </header>
      ) : null}
      <div className={classNames("ui-card__body", bodyClassName)}>{children}</div>
    </section>
  );
}

